// LIBS
import React from 'react'
import {Helmet} from 'react-helmet'
import {renderIf, getOr} from '../../lib/util.js'
import {get, union} from 'lodash/fp'

// DEFAULTS
const defaultDescription = 'Code Fellows is the Pacific Northwests premier technical skills training academy, delivering high-quality live instruction both online and in person to people from all backgrounds.'
const defaultImage = 'https://images.ctfassets.net/k428n7s2pxlu/33vVeNI87n8NMv6nvSKo98/36051c0d470335a657b8816f9a14cc84/test-drive.webp'
const defaultKeywords = [
  'Code Fellows',
  'cybersecurity',
  'cybersecurity school',
  'devops',
  'tech support',
  'code school',
  'coding school',
  'coding bootcamp',
  'Seattle coding school',
  'Seattle coding bootcamp',
  'computer coding classes Seattle',
]

// INTERFACE
// this is used within Helmet and helmet does not allow for nested compoennts
// so this returns an array (and all iterators need unique key props in react)
// useage is {MetaData(data)} dont use <MetaData data={data} /> it wont work
export default ({data, children}) => {
  let title = (data.title || 'Code Fellows').trim()
  let description = getOr(['metaDescription', 'description'], data) || defaultDescription
  let twitterAuthor = get('author.fields.twitter', data) || '@codefellows'
  let image = getOr([ 'imageHeader.fields.file.url', 'image.fields.file.url'], data) || defaultImage
  image = image.startsWith('//') ? 'https:' + image : image
  let canonicalUrl = 'https://www.codefellows.org/' + (data.slug ? data.slug + '/' : '' )
  let keywords = union(defaultKeywords, data.keywords).join(',')

  return (
    <Helmet itemScope itemType="http://schema.org/WebPage">
      {/* GENERAL */}
      <meta  charSet="utf-8" />
      <title itemProp='headline'>{title}</title>
      <link itemProp='sameAs' rel="canonical" href={canonicalUrl} />
      <meta itemProp='description' name='description' content={description} />
      <meta itemProp='keywords' name='keywords' content={keywords} />

      {/* OPEN GRPAH*/}
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Code Fellows" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* FACEBOOK */}
      <meta property="fb:admins" content="379865715439924" />
      
      {/* TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@codefellows" />
      <meta name="twitter:creator" content={twitterAuthor} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {renderIf(children, children)}
    </Helmet>
  )
}



// WEBPACK FOOTER //
// ./src/components/meta-data/index.js